export enum Service {
  ATLAS_CONFIG = 'configs',
  PROVIDER = 'providers',
  CONTENT = 'contents',
  CAMPAIGN = 'campaign',
  CONTENT_GROUP = 'contentgroups',
  LICENSE = 'licenses',
  CONTENT_PROCESS = 'contentprocess',
  CONTENT_RELEASEDATE = 'contentreleasedate',
  CONTENT_NOTE = 'contentnote',
  CONTENT_DUBSUB = 'contentdubandsub',
  CHANNEL = 'channels',
  CHANNEL_GROUP = 'channelgroups',
  CONTRACT = 'contracts',
  LOGIN = 'auth',
  SUBSCRIBER = 'subscriber',
  CRON_JOB = 'cronjob',
  JOB = 'jobs',
  ENCODING_PROFILE = 'encodingprofiles',
  ENCODER = 'encoders',
  ENCODING_STATION = 'encodingstations',
  DRM_PROFILE = 'drmprofile',
  METADATA_ENRICHMENT = 'metadatacustomkeys',
  DEVICE_PROFILE = 'deviceprofile',
  POSTER_DEFINITION = 'posterdefinitions',
  EPG_POSTER_DEFINITION = 'epgposterdefinition',
  LABEL = 'labels',
  CATEGORY = 'categories',
  PUBLISHING_POINT = 'publishpoint',
  MAINBOARDITEM = 'mainboarditem',
  PROGRAM = 'programs',
  EPG = 'epg',
  OPERATIONAL = 'operational',
  PRESENTATION = 'presentations',
  CONFIG = 'configuration',
  NOTIFICATION_MESSAGE = 'NotificationMessage',
  METADATA_TEMPLATE = 'metadatatemplates',
  LANGUAGE = 'languages',
  PODCAST_CONTENT = 'podcastcontent',
  PODCAST = 'podcast',
  PODCAST_GROUP = 'podcastgroup',
  USERS = 'users',
  CATCHUP = 'catchups',
  CATCHUP_REQUEST = 'catchuprequests',
  PROGDEF = 'programdefinitions',
  RECORD = 'recording',
  AUDITLOGS = 'auditlogs',
  PURCHASEVODS = 'product-purchases',
  THEMES = 'themes',
  REMINDERS = 'reminders',
  TIMES_CODECS = 'contenttimecodes',
  SESSION_QUOTA = 'sessionquotas',
  USER_DEVICES = 'devices',
  MULTI_LANG = 'contentlanguagemetadatas',
  CATEGORY_LANG = 'categorylanguages',
  AUTO_PROCESS = 'autoprocesses',
  AUTO_PROCESS_LOG = 'autoprocesslog',
  CUST_RECORDS = 'recordings',
  MULTICAST_INPUT = 'channelmulticastinput',
  MULTICAST_OUTPUT = 'channelmulticastoutput',
  THIRDPARTY_AGENCY = 'thirdpartyagencies',
  PLAN_PROFILES = 'planprofiles',
  MENU_ITEMS = 'menuitems',
  KEYWORD = 'keywords',
  GENRE = 'genres',
  ERROR_LOGS = 'errorlogs',
  CDN_DOWNLOAD_PLAY_URL = 'downloadrequests',
  ERROR_CODES = 'errorcodes',
  CAST = 'casts',
  CASTV2 = 'v2/casts',
  PROGRAM_GROUPS = 'programgroups',
  EPG_CORRECTION_JOBS = 'epgcorrectionjobs',
  AUDIT = 'audit',
  OPUSERS = 'opusers',
  LABEL_LANGUAGES = 'labellanguages',
  ROLES = 'roles',
  REPORT_REQUEST = 'reportrequests',
  MW = 'mw',
  VIDEO_OP = 'videooperationtasks',
  PRIVILEGES = 'privileges',
  PAGES = 'pages',
  COMING_SOON = 'comingsooncontents',
  VALIDATION = 'validationevents',
  ISSUETYPE = 'contentissuetypes',
  ACTIVITYLOGS = 'activitylogs',
  TRAILER_OPERATION_TASKS = 'traileroperationtasks',
  AUTO_PROCESS_JOBS = 'autoprocessjobs',
  SEARCH_NAVIGATION = 'searchnavigation',
  EPG_IMPORT_LOGS = 'epgimportlogs',
  AUTO_PROCESS_ITEMS = 'autoprocessitems',
  POSTER_SERVICE = 'posters',
  POSTER_SERVICEV2 = 'v2/posters',
  EPG_ACTIVITYLOGS = 'epgactivitylogs',
  FILTER_PRESETS = 'filterpresets',
  SPECIAL_CONTENTS = 'specialcontents',
  VALIDATION_EVENT_ACTIVITY_LOGS = 'validationeventactivitylogs',
  VOP_KPI_DATA = 'vopkpidata',
  BANNER = 'banners',
  BANNER2 = 'bannerss',
  BANNER_POSTER_DEFINITION = 'bannerposterdefinitions',
  CPI = 'cpi-content',
  CONTENT_LANG = 'content-languages',

  // CRM
  CRM = "crm",
  CUSTOMER = "customers",
  CUSTOMER_GROUP = "customer-groups",
  PRODUCT = "product",
  PACKAGE = "packages",
  REPORT = "reportrequests",
  SESSION = "session",
  DEMO_CAMPAIGN = "demo-campaigns",

  CONTENT_SECTION_INFO = 'contentsectioninfo',

  EPG_TRIM = 'epgtrim',

  CHANNEL_STREAM_CONFIG = 'channelstreamconfigs',
  CHANNEL_STREAM_SETTING = 'channelstreamsettings',
  CHANNEL_DETAIL = 'channel-detail',

  ENCODER_SETTING = 'encodersettings',

  USER = "user",
  SUBSCRIPTION_API = 'crm/subscription'
}
